import { Host, h } from '@stencil/core';
import classNames from '../../../utils/classnames.utils';
export class AibaSpinner {
  constructor() {
    this.alignment = 'horizontal';
    this.spinnerCircleColorType = undefined;
    this.text = undefined;
    this.styles = undefined;
    this.classes = undefined;
    this.loaderCircleWidthValue = '4';
    this.backgroundCircleWidthValue = '4';
    this.i = 0;
  }
  componentWillLoad() {
    this.i++;
  }
  getCssClassMap() {
    const name = 'spinner';
    const prefix = `${name}--`;
    return classNames(name, this.alignment && `${prefix}alignment-${this.alignment}`, this.text && `${prefix}text`, this.spinnerCircleColorType && `${prefix}circle-color-${this.spinnerCircleColorType}`, this.classes && `${this.classes}`);
  }
  render() {
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: this.getCssClassMap() }, h("div", { class: "spinner__container" }, h("svg", { class: "spinner__circle", viewBox: "0 0 50 50" }, h("circle", { class: "path", cx: "25", cy: "25", r: "20", fill: "none", "stroke-width": this.loaderCircleWidthValue })), h("svg", { class: "spinner__circle-background", viewBox: "0 0 50 50" }, h("circle", { class: "path", cx: "25", cy: "25", r: "20", fill: "none", "stroke-width": this.backgroundCircleWidthValue }))), this.text ? h("div", { class: "spinner__text" }, this.text) : h("div", null))));
  }
  static get is() { return "aiba-spinner"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-spinner.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-spinner.css"]
    };
  }
  static get properties() {
    return {
      "alignment": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'horizontal' | 'vertical'",
          "resolved": "\"horizontal\" | \"vertical\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "alignment",
        "reflect": false,
        "defaultValue": "'horizontal'"
      },
      "spinnerCircleColorType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'primary' | 'secondary' | 'tertiary'",
          "resolved": "\"primary\" | \"secondary\" | \"tertiary\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "spinner-circle-color-type",
        "reflect": false
      },
      "text": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "text",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "loaderCircleWidthValue": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "loader-circle-width-value",
        "reflect": false,
        "defaultValue": "'4'"
      },
      "backgroundCircleWidthValue": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "background-circle-width-value",
        "reflect": false,
        "defaultValue": "'4'"
      }
    };
  }
  static get states() {
    return {
      "i": {}
    };
  }
}
//# sourceMappingURL=aiba-spinner.js.map
